import { config } from "Utils/config";
import { logS } from "../Util/Utilities";

const COMMENT_ACTIONS = {
    
    SET_INITIAL_DATA: 'set-data',
    TEXT_CHANGE: 'text-change',
    TEXT_SET_ERRORS: 'text-set-errors',
    TEXT_SET_SUCCESS: 'text-set-success',
    TEXT_REMOVE_ERRORS: 'text-remove-errors',
    TEXT_AREA_CHANGE: 'text-area-change',

    CLEAR: 'clear',

    ADD_COMMENT: 'add-comment',
    REMOVE_COMMENT: 'remove-comment',
    UPDATE_COMMENT: 'update-comment',
    UPDATE_COMMENT_STATUS: 'update-comment-status',
    ADD_COMMENT_ERRORS: 'add-comment-errors'
};

const commentStateReducer = (state, action) => {
    var name = "TempList";
    var type = action != null && action.hasOwnProperty("type") ? action.type : null;
    config.isDebugEnabled && console.log("%cDispatch %c- %s -", logS.colors.brown, logS.bold,type, name, state, action);
    switch (action.type) {
        case COMMENT_ACTIONS.SET_INITIAL_DATA: {
            return {
                ...state
            };
        }
        case COMMENT_ACTIONS.CLEAR: {
                return {
                    
                };
            }
        case COMMENT_ACTIONS.ADD_COMMENT: {
            var i = {
                ...action.input,
                value: (action.input.value).trim()
            }
            return {
                ...state,
                [action.item.id]:{
                    item: action.item,
                    input: i,
                    date: action.date,
                    status: action.status
                }
            };
        }
        case COMMENT_ACTIONS.UPDATE_COMMENT: {
            var i = {
                ...action.input,
                value: (action.input.value).trim()
            }
            return {
                ...state,
                [action.item.id]:{
                    ...state[action.item.id],
                    item: action.item,
                    input: i,
                    date: action.date,
                    status: action.status
                }
            };
        }
        case COMMENT_ACTIONS.UPDATE_COMMENT_STATUS: {
            return {
                ...state,
                [action.name]:{
                    ...state[action.name],
                    status: action.status
                }
            }; 
        }
        case COMMENT_ACTIONS.REMOVE_COMMENT: {
            const array = Object.entries(state);
            const filtered = array.filter(([key,value]) => value.item.id !== action.id);
            const obj = Object.fromEntries(filtered);
            return obj;
        }

        case COMMENT_ACTIONS.TEXT_AREA_CHANGE: {  
            var content = action.value;
            var maxLength = action.maxLength;
            var text = content.substring(0,maxLength);

            return {
                ...state,
                [action.name]:{
                    ...state[action.name],
                    input: {
                        ...state[action.name].input,
                        value: text,
                        count: text.length,
                        validation:{
                            ...state[action.name].input.validation,
                            isInvalid: false,
                            errors: [],
                            isValid: false,
                            successMsgs: []
                        }
                    }
                }
            }; 
        }
        case COMMENT_ACTIONS.TEXT_SET_ERRORS: {
            return {
                ...state,
                [action.name]:{
                    ...state[action.name],
                    input: {
                        ...state[action.name].input,
                        validation:{
                            ...state[action.name].input.validation,
                            isInvalid: action.errors != null && action.errors.length > 0 ? true : false,
                            errors: action.errors,
                            isValid: false,
                            successMsgs: []
                        }
                    }
                }
            }; 
        }
        
    }
}



export {COMMENT_ACTIONS, commentStateReducer};